/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* Licensed under the MIT License. See LICENSE.md in the project root for license terms.
*--------------------------------------------------------------------------------------------*/

import React from "react";
import MarkdownJsx, { MarkdownToJSX } from "markdown-to-jsx";
import styles from "./Markdown.module.css";
import { ErrorBoundary } from "react-error-boundary";

export interface MarkdownProps extends Pick<React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>, "style" | "className"> {
  children: string;
  options?: MarkdownToJSX.Options
}

export const MarkdownRenderer = ({ children, style, options, className }: MarkdownProps) => {
  const selfClosingTags = { br: () => <br />, col: () => <col />, hr: () => <hr />, wbr: () => <wbr /> }
  const mergedOverridesOptions = Object.assign({}, options, { overrides: Object.assign({}, options?.overrides, selfClosingTags) });

  return (
    <div className={styles.container}>
      <div className={[styles.markdown, className ?? ""].join(" ")} style={style}>
        <ErrorBoundary fallbackRender={({ error }) => { return <div> Error rendering Markdown: {error.message} </div> }}>
          <MarkdownJsx options={mergedOverridesOptions}>{children}</MarkdownJsx>
        </ErrorBoundary>
      </div>
    </div>
  );
}
